import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-494c4190"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "grid" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "noData",
  hidden: ""
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "alert alert-info",
    role: "alert"
  }, " No employees available in the speciefied date ranges. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, null, 512),
    _hoisted_2
  ], 64))
}